/**
 *
 */
import COMPANY_CONFIG from '../config/company.config.js'
import navbar_1 from '@/assets/img/navbar_1.png'
import navbar_2 from '@/assets/img/navbar_2.png'
import navbar_3 from '@/assets/img/navbar_3.png'
import navbar_4 from '@/assets/img/navbar_4.png'
// import navbar_5 from '@/assets/img/navbar_5.png'
import navbar_6 from '@/assets/img/navbar_6.png'
// /*name: '手帐',gatherId: 5,icon: navbar_5,list: [{partType: 10001,name: '手语学习'}, {partType: 10002,name: '单词学习'}, {partType: 10003,name: '歌曲学习'}, {partType: 10004,name: '思维导图'}, {partType: 10005,name: '趣味涂鸦'}]}, {*/
const Config = {
	defaultMenu: [{
		name: '课程',
		gatherId: 1,
		icon: navbar_1
	}, {
		name: '词句',
		gatherId: 2,
		icon: navbar_2,
		list: [{
			partType: 29,
			name: '外教导学'
		}, {
			partType: 38,
			name: '单词跟读'
		}, {
			partType: 21,
			name: '跟读训练'
		}, {
			partType: 30,
			name: '手语教学'
		}]
	}, {
		name: '歌曲',
		gatherId: 3,
		icon: navbar_3,
		list: [{
			partType: 23,
			name: '歌曲导学'
		}, {
			partType: 22,
			name: '歌曲欣赏'
		}, {
			partType: 24,
			name: '歌曲表演'
		} /*, { partType: 31, name: '拓展歌曲' }*/]
	}, {
		name: '游戏',
		gatherId: 4,
		icon: navbar_4,
		list: [{
			partType: 26,
			name: '单词游戏'
		}, {
			partType: 28,
			name: '游戏涂鸦'
		}, {
			partType: 27,
			name: '手工游戏'
		}, {
			partType: 39,
			name: '思维训练'
		}]
	}, {
		name: '综合',
		gatherId: 323334,
		icon: navbar_6
	}],
	// watermark: '?x-oss-process=image/watermark,image_ZmlsZS93YXRlcm1hcmsvbG9nby5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xNQ,g_nw,t_70,x_0,y_0',
	// watermark: COMPANY_CONFIG.watermark
	watermark: ''
}
export default Config;